import { TextField } from '@/components'

interface FirmNameFieldProps {
  defaultValue?: string
  error?: string | null
  setFieldValue: (name: string, value?: string) => void
  isMutating?: boolean
  label?: string
  placeholder?: string
  helpText?: string
  required?: boolean
}

export const FirmNameField = ({
  defaultValue,
  error,
  setFieldValue,
  label = 'Firm Name',
  placeholder = 'Type the name of your firm',
  helpText = 'This name will appear on your dashboard and in billing correspondence.',
  required = true,
}: FirmNameFieldProps) => (
  <TextField
    label={label}
    id="firm-name"
    placeholder={placeholder}
    defaultValue={defaultValue}
    error={error}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
      setFieldValue('accountName', e.target.value)
    }
    required={required}
    helpText={helpText}
  />
)
